import type { Transition, Variants } from 'framer-motion';
import type { ReactNode } from 'react';
import type { NotificationCategory, NotificationFooterActionItem, NotificationItem } from '@/services/notification/type';

export type AnimationDirection = 1 | -1;

const EASE_CURVE: [number, number, number, number] = [0.4, 0, 0.2, 1];

export const slideVariants: Variants = {
  enter: (direction: AnimationDirection) => ({
    x: direction === 1 ? '100%' : '-100%',
    opacity: 0,
  }),
  center: {
    x: 0,
    opacity: 1,
  },
  exit: (direction: AnimationDirection) => ({
    x: direction === 1 ? '-100%' : '100%',
    opacity: 0,
  }),
};

export const SLIDE_TRANSITION: Transition = {
  duration: 0.3,
  ease: EASE_CURVE,
};

export const scaleVariants: Variants = {
  visible: { scale: 1, opacity: 1 },
  hidden: { scale: 0.8, opacity: 0 },
};

export const SCALE_TRANSITION: Transition = {
  duration: 0.25,
  ease: EASE_CURVE,
};

export interface NotificationPanelProps {
  notifications: NotificationItem[];
  loading: boolean;
  selectedId: string | null;
  selectedNotification: NotificationItem | null;
  unreadCount: number;
  updateUnread: number;
  forYouUnread: number;
  activeTab: NotificationCategory;
  showBackButton?: boolean;
  showCloseButton?: boolean;
  onSwitchTab: (tab: NotificationCategory) => void;
  onSelect: (id: string) => void;
  onGoBack: () => void;
  onMarkAllAsRead: () => void;
  onLoadMore: () => void;
  onClose: () => void;
  onAction: (notification: NotificationItem, action: NotificationFooterActionItem) => void;
}

export interface ActionIconButtonProps {
  ariaLabel: string;
  disabled?: boolean;
  tooltip?: string;
  onClick?: () => void;
  children: ReactNode;
}
